<button [id]='id' class="or-button or-checkbox" [disabled]="disabled" (click)="toggle()" [ngClass]="{ 'or-active': value }" [attr.data-cy]='dataCy'>
  <span class="or-button or-checkbox-control">
    <span class="or-icon or-tiny or-icon-checkmark or-checkbox-checkmark"></span>
  </span>
  @if (label) {
    <span class="or-checkbox-label">{{ label }}</span>
  }
</button>
